<div class="u-shadow-mini {{ sectionclass }}">
	<app-loader [showLoader]="showLoad"></app-loader>

	<div class="c-portlet_box_specs">
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap"
		>
			<div class="o-stack__cell">
				<h5>{{ sectiontitle }}</h5>
				<span class="sub-title">{{ selectedFieldName }} by device type</span>
				<span *ngIf="hasData">
					<a
						href="javascript:void(0)"
						class="datatable_download_icon"
						(click)="downloadCSV()"
						target="_blank"
						*ngIf="downloadConfiguration && downloadConfiguration.enableDownload"
					>
						<i class="fa fa-download" aria-hidden="true"></i>
					</a>
				</span>
			</div>
		</div>
		<div class="analytics-portlet-content">
			<div class="o-stack o-stack--nowrap o-stack--center">
				<div style="width: 100%" *ngIf="hasData">
					<span class="sub-title inner-sub-title" style="color: transparent"
						>{{ selectedFieldName }} by device type</span
					>
					<ngu-carousel #carousel [inputs]="carouselOne" [dataSource]="deviceChartObjArray" (onMove)="onmoveFn($event)">
						<ngu-tile *nguCarouselDef="let deviceChartObj">
							<app-donut
								*ngIf="!isR103 && !isR104"
								[chartConfigurationObj]="{
									seriesName: deviceChartObj?.seriesName,
									datalabelsEnabled: isR8 ? false : true,
									svgWidth: piechartconfiguration?.width,
									svgHeight: isR8 && piechartconfiguration?.height ? piechartconfiguration?.height : undefined,
									innerSize: piechartconfiguration?.innerSize,
									verticalAlign: piechartconfiguration?.verticalAlign,
									margin: piechartconfiguration?.margin,
								}"
								[chartData]="deviceChartObj?.chartObj"
								[isR8]="isR8"
							></app-donut>
							<app-donut
								*ngIf="isR103"
								[chartConfigurationObj]="{
									seriesName: deviceChartObj?.seriesName,
									datalabelsEnabled: false,
									svgWidth: piechartconfiguration?.width,
									svgHeight: piechartconfiguration?.height,
									innerSize: piechartconfiguration?.innerSize,
									verticalAlign: piechartconfiguration?.verticalAlign,
									margin: piechartconfiguration?.margin,
									align: piechartconfiguration?.legendConfig?.align,
									layout: piechartconfiguration?.legendConfig?.layout,
									verticalAlign: piechartconfiguration?.legendConfig?.verticalAlign,
									symbolRadius: piechartconfiguration?.legendConfig?.symbolRadius,
									itemMarginTop: piechartconfiguration?.legendConfig?.itemMarginTop,
									addSeriesNameToLables: piechartconfiguration?.legendConfig?.addSeriesNameToLables,
									specialLegendText: piechartconfiguration?.legendConfig?.specialLegendText,
									padding: piechartconfiguration?.legendConfig?.padding,
								}"
								[chartData]="deviceChartObj?.chartObj"
							></app-donut>
							<app-donut
								*ngIf="isR104"
								[chartConfigurationObj]="{
									seriesName: deviceChartObj?.seriesName,
									datalabelsEnabled: flase,
									svgWidth: piechartconfiguration?.width,
									innerSize: piechartconfiguration?.innerSize,
									verticalAlign: piechartconfiguration?.verticalAlign,
									margin: piechartconfiguration?.margin
								}"
								[chartData]="deviceChartObj?.chartObj"
							></app-donut>
						</ngu-tile>

						<span *ngIf="!isR103" NguCarouselPrev class="leftRs" [hidden]="deviceChartObjArray.length === 1">
							<i class="fa fa-angle-left" aria-hidden="true"></i>
						</span>
						<span *ngIf="!isR103" NguCarouselNext class="rightRs" [hidden]="deviceChartObjArray.length === 1">
							<i class="fa fa-angle-right" aria-hidden="true"></i>
						</span>

						<span *ngIf="isR103" NguCarouselPrev class="leftRs" [hidden]="deviceChartObjArray.length === 1">
							<i>
								<svg xmlns="http://www.w3.org/2000/svg" width="43" height="50" viewBox="0 0 43 50" fill="none">
									<g clip-path="url(#clip0_3552_40262)">
										<path
											d="M7.41113 13.9365C6.53223 14.8014 6.53223 16.2061 7.41113 17.0711L20.9111 30.3568C21.79 31.2217 23.2174 31.2217 24.0963 30.3568C24.9752 29.4918 24.9752 28.0871 24.0963 27.2222L12.1854 15.5003L24.0893 3.77843C24.9682 2.91348 24.9682 1.50879 24.0893 0.643834C23.2104 -0.221122 21.783 -0.221122 20.9041 0.643834L7.4041 13.9295L7.41113 13.9365Z"
											class="primary-color-bg primary-svg-fill"
											fill="#283D3B"
										/>
									</g>
									<defs>
										<clipPath id="clip0_3552_40262">
											<rect width="50" height="43" fill="white" transform="matrix(0 1 1 0 0 0)" />
										</clipPath>
									</defs>
								</svg>
							</i>
						</span>
						<span *ngIf="isR103" NguCarouselNext class="rightRs" [hidden]="deviceChartObjArray.length === 1">
							<i>
								<svg xmlns="http://www.w3.org/2000/svg" width="43" height="50" viewBox="0 0 43 50" fill="none">
									<g clip-path="url(#clip0_3552_40266)">
										<path
											d="M28.5889 17.0635C29.4678 16.1986 29.4678 14.7939 28.5889 13.9289L15.0889 0.643217C14.21 -0.221739 12.7826 -0.221739 11.9037 0.643217C11.0248 1.50817 11.0248 2.91286 11.9037 3.77782L23.8146 15.4997L11.9107 27.2216C11.0318 28.0865 11.0318 29.4912 11.9107 30.3562C12.7896 31.2211 14.217 31.2211 15.0959 30.3562L28.5959 17.0705L28.5889 17.0635Z"
											class="primary-color-bg primary-svg-fill"
											fill="#283D3B"
										/>
									</g>
									<defs>
										<clipPath id="clip0_3552_40266">
											<rect
												width="50"
												height="43"
												fill="white"
												transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 43 50)"
											/>
										</clipPath>
									</defs>
								</svg>
							</i>
						</span>
					</ngu-carousel>
				</div>
			</div>
			<div class="no-data-container" *ngIf="!hasData">
				<div class="map-no-data">No Data to Display</div>
			</div>
		</div>
	</div>
</div>
